'use strict';

import {changeLangToCurrent} from "../langSwitcher/langSwitcher";
import {isDesktop, isMobile, settingsData} from "../../../settings";
import {
    changePlaceholder, customiseForm,
    moveFormToBlock,
    setPropId,
    setTranslateToCheckbox,
    setTranslateToSendBtn,
} from '../form/form';
import { contactToAgentWithWidget } from '../chats/chats';

function creatHtmlElement(parent, elementName, elementTag, elementClass) {
    const el = document.createElement(elementTag);

    if (Array.isArray(elementClass)) {
        elementClass.forEach(classElement => {
            el.classList.add(classElement);
        });
    } else {
        el.style.cssText = elementClass;
    }
    el.textContent = elementName;
    if (parent)
        parent.appendChild(el);

    return el;
}

export function chatsApplyNow(parent, contentObject) {
    const isiOS = iOS();
    // const phoneNumberUse = ['sms','call'];

    const mainContainer = creatHtmlElement(parent, '', 'div', ['apply__main-container','chats','hidden']);
    const contentWrapper = creatHtmlElement(mainContainer, '', 'div', ['apply__content__wrapper']);
    const titleContainer = creatHtmlElement(contentWrapper, '', 'div', ['apply__title-container']);
    const title = creatHtmlElement(titleContainer, `${changeLangToCurrent('leadFormTitle')}`, 'h2', ['apply__title', 'language-string']);
    title.dataset.dictionary = 'leadFormTitle';
    const span = creatHtmlElement(titleContainer, changeLangToCurrent(contentObject.subTitle.text), 'span', ['apply__sub-title', 'language-string']);
    span.dataset.dictionary = contentObject.subTitle.dic;
    //Icons
    const socialIcons = creatHtmlElement(contentWrapper, '', 'ul', ['apply__social-icons']);

    if (config.communications?.length === 0)
        return mainContainer;

    contentObject.channelsConfig.forEach(channel => {
        const isActive = config.communications?.find(channelConf => channelConf.type === channel.name)?.active;
        if (!isActive)
            return;

        if (!isiOS && channel.name === "facetime")
            return;

        const currentPrefix = channel.prefix;
        let currentHref = config.communications.find(channelConf => channelConf.type === channel.name).value;

        /* Remove '+' from whatsapp number */
        if (channel.name === 'whatsapp' && currentHref)
            currentHref = currentHref.replace('+','');

        const socialIconItem = creatHtmlElement(socialIcons, '', 'li', ['apply__social-icon__item']);
        const href = creatHtmlElement(socialIconItem, '', 'a', ['apply__social-href']);
        href.href = currentPrefix + currentHref;
        (channel.target) ? href.setAttribute('target', channel.target) : '';
        const socialImg = creatHtmlElement(href, '', 'span', ['custom-icon', channel.icon]);
        socialImg.src = `src/img/social-icons/${channel.name.toLowerCase()}.svg`;
        socialImg.alt = changeLangToCurrent(channel.name);
        const socialIconText = creatHtmlElement(href, changeLangToCurrent(channel.dic), 'span', ['apply__social-icon__text', 'language-string']);
        socialIconText.dataset.name = channel.name;
        socialIconText.dataset.dictionary = channel.dic;
    });

    return mainContainer;
}

export async function applyNow(parent, contentObject, useSubstrate = true, hideElementsArr = [], object) {
    const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;
    const isiOS = iOS();

    if (document.querySelector('.apply__main-container__outer'))
        return;

    if (config.contactWidget.active) {
        contactToAgentWithWidget(object);
        return;
    }

    let mainContainerOuter;
    let mainContainer;

    if (useSubstrate) {
        mainContainerOuter = creatHtmlElement(parent, '', 'div', ['apply__main-container__outer', 'non-canvas']);
        mainContainer = creatHtmlElement(mainContainerOuter, '', 'div', ['apply__main-container', 'non-canvas']);
    } else {
        mainContainer = creatHtmlElement(parent, '', 'div', ['apply__main-container']);
    }

    !isMobile && setWidthOfApplyNow();

    const contentWrapper = creatHtmlElement(mainContainer, '', 'div', ['apply__content__wrapper']);
    const closeBtn = creatHtmlElement(mainContainer, '', 'div', ['apply-btn__close', 'icon-close']);
    closeBtn.setAttribute('id', 'applyCloseBtn');
    const titleContainer = creatHtmlElement(contentWrapper, '', 'div', ['apply__title-container']);
    const title = creatHtmlElement(titleContainer, `${changeLangToCurrent(contentObject.title.text)}`, 'h2', ['apply__title', 'language-string']);
    title.dataset.dictionary = contentObject.title.dic;
    const span = creatHtmlElement(titleContainer, changeLangToCurrent(contentObject.subTitle.text), 'span', ['apply__sub-title', 'language-string']);
    span.dataset.dictionary = contentObject.subTitle.dic;
    //Icons
    const socialIcons = creatHtmlElement(contentWrapper, '', 'ul', ['apply__social-icons']);
    contentObject.channelsConfig.forEach(channel => {

        if (config.features.applyNow.channels.length === 0)
            return;

        const isActive = config.features.applyNow.channels.find(channelConf => channelConf.type === channel.name)?.active;
        if (!isActive)
            return;

        if (!isiOS && channel.name === "facetime")
            return;

        const currentPrefix = channel.prefix;
        const currentHref = config.features.applyNow.channels.find(channelConf => channelConf.type === channel.name).href;
        const socialIconItem = creatHtmlElement(socialIcons, '', 'li', ['apply__social-icon__item']);
        const href = creatHtmlElement(socialIconItem, '', 'a', ['apply__social-href']);
        href.href = currentPrefix + currentHref;
        (channel.target) ? href.setAttribute('target', channel.target) : '';
        const socialImg = creatHtmlElement(href, '', 'span', ['custom-icon', channel.icon]);
        socialImg.src = `src/img/social-icons/${channel.name.toLowerCase()}.svg`;
        socialImg.alt = changeLangToCurrent(channel.name);
        const socialIconText = creatHtmlElement(href, changeLangToCurrent(channel.dic), 'span', ['apply__social-icon__text', 'language-string']);
        socialIconText.dataset.name = channel.name;
        socialIconText.dataset.dictionary = channel.dic;
    });

    hideElements(hideElementsArr);

    closeBtn.addEventListener('click', () => {
        closeBtnHandler();
        showElements(hideElementsArr);
    });
    // ADD Form
    if (config.general.leadForm || settingsData.isConferenceHost)  {
        const form = document.querySelector('.form__container-main');
        moveFormToBlock(contentWrapper);
        customiseForm(form);
        setTranslateToSendBtn(form);
        changePlaceholder(form);
        setPropId(contentWrapper, object);
        setTranslateToCheckbox(form);
    }

    if (isSafari && isMobile)
        contentWrapper.style.marginTop = '62px';
}

export const setWidthOfApplyNow = () => {
    const applyContainer = document.querySelector('.apply__main-container:not(.chats)');

    if (!applyContainer || isMobile)
        return;

    const menuWidth = document.querySelector('.aside__container').getAttribute('data-initial-width');
    let width = window.innerWidth - menuWidth;
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    applyContainer.style.width = `${width}px`;

    if (isDesktop) {
        applyContainer.style.right = `${menuWidth}px`;
        applyContainer.style.left = `initial`;
    } else {
        if (rtl) {
            applyContainer.style.right = `${menuWidth}px`;
            applyContainer.style.left = `initial`;
        } else {
            applyContainer.style.right = `initial`;
            applyContainer.style.left = `${menuWidth}px`;
        }
    }
}

function hideElements(hideArray) {
    if (hideArray.length > 0) {
        hideArray.forEach(element => {
            const domElement = document.querySelector(`.${element}`);
            if (domElement) {
                domElement.style.display = 'none';
            }
        });
    }
}

function showElements(elementsArr) {
    if (elementsArr.length > 0) {
        elementsArr.forEach(element => {
            const domElement = document.querySelector(`.${element}`);
            if (domElement) {
                domElement.style.removeProperty('display');
            }
        });
    }
}

export function closeBtnHandler() {
    const applyContainer = document.querySelector('.apply__main-container:not(.chats)');
    const applyContainerOuter = document.querySelector('.apply__main-container__outer');

    moveFormToBlock();

    if (applyContainerOuter) {
        applyContainerOuter.remove();
        applyContainer.remove();
    } else {
        const applyContainer = document.querySelector('.apply__main-container:not(.chats)');
        applyContainer.remove();
    }
}

function iOS() {
    return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
            'MacIntel',
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}